import { cn } from '../../utils';

interface CardWizardProps {
  children: React.ReactNode;
  addOnClass?: string;
  style?: React.CSSProperties;
}

const CardWizard: React.FC<CardWizardProps> = ({
  children,
  addOnClass = '',
  style = {},
}) => {
  const isLineItemSection = addOnClass.includes(
    'flex flex-col gap-1 p-4 px-0 py-0',
  );

  return (
    <div
      data-card-wizard="true"
      data-card-variant={isLineItemSection ? 'line-item' : 'surface'}
      className={cn(`bg-white  rounded-sm  w-full`, addOnClass)}
      style={{
        boxShadow:
          'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default CardWizard;
